module.exports = __webpack_public_path__ + "static/media/mSlider1.b359622c.png";